/**
 * Created by tomers on 1/28/2015.
 *
 **********************************************************************************************************
 **************************************** SINGLE SELECT INITIALIZE ****************************************
 **********************************************************************************************************
 var singleselect = new Singleselect({
        container: $(), // the singleselect container
        permutation: Singleselect.PERMUTATION.FULL, // actualy InputField.Permutation. the permutation is a permutation from Singleselect.PERMUTATION Enum. the permutation responsible for the component width
        asyncFilter: false, // true for async list filtering. default is false. If you are using asyncFilter you should listen to "filter" event.
        asyncFilterMinChars: 3, // minimum num of chars before the component triggers the "filter" event. default is 3
        floating: true, // if the list within the singleselect component is floating or not (regardless if the list has "floating" class name). default is true
        errorPosition: Singlelselect.ERROR_POSITION.RIGHT // taken from InputField.ERROR_POSITON. the position of the error message. default is from InputField
        errorAlign: Singlelselect.ERROR_ALIGN.MIDDLE //  taken from InputField.ERROR_ALIGN. the alignment of the error message. default is from InputField
        items: [ // same as items in List component
            {
                id: 1,
                value: "Item 1",
                group: "group A"
            }
        ],
        selectedItem: 1 // selected item id - optional
        list: {
            // any List options you want to send to the List component of this Singleselect (without items and selectedItems)
            //  for example - newItem: {visible:true}
        },
        inputField: {
            // any InputField options you want to send to the InputField component of this Singleselect (without value and permutation)
            //  for example - placeholder: "input placeholder"
        }
 });
 *************************************************************************************************
 *************************************************************************************************
 *************************************************************************************************
 *
 *
 */
define(function (require) {
    "use strict";

    //<editor-fold desc="require-region">
    /*-----------------------------------------------------------------------------------------------*/
    var Marionette = require("marionette");
    var Logger = require("logger");
    var _ = require("underscore");
    var $ = require("jquery");

    //Template
    var template = require("ui/singleselect-new/templates/singleselect.tmpl");

    //Components
    var InputField = require("ui/input-field/InputField");
    var List = require("ui/list/List");
    var Loader = require("ui/loader/Loader");

    //Multiselect MVC
    var SingleselectModel = require("ui/singleselect-new/js/models/SingleselectModel");
    //</editor-fold>

    var PERMUTATION = InputField.Permutation;
    var TRIGGERING = {
        CHANGE: "change",
        INPUT_CHANGE: "input:change",
        BLUR: "blur",
        CREATE: "create",
        REMOVE: "remove"
    };

    var THEME = {
        DEFAULT: {
            INPUT_FIELD: InputField.THEME.DEFAULT,
            LIST: List.THEME.DEFAULT
        },
        NIGHT: {
            INPUT_FIELD: InputField.THEME.NIGHT,
            LIST: List.THEME.NIGHT
        }
    };

    var FLOATING_CLASS_NAME = "floating";

    var Singleselect = Marionette.ItemView.extend({

        //<editor-fold desc="extended definitions">
        /*-----------------------------------------------------------------------------------------------*/
        className: "singleselect-component-container",
        template: template,
        ui: {
            inputField: ".input-field-container",
            list: ".list-container",
            loader: ".loader-container"
        },
        withUIComponents: true,
        //</editor-fold>


        //<editor-fold desc="Marionette-Functions">
        /*-----------------------------------------------------------------------------------------------*/
        initialize: function(options) {
            this._initialize(options);
        },
        onRender: function() {
            this._onRender();
        },
        onClose: function() {
            this._onClose();
        },
        //</editor-fold>

        //<editor-fold desc="publicFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        showLoader: function(show, isFullLoader) {
            this._showLoader(show, isFullLoader);
        },
        addItem: function(item) {
            this._addItem(item);
        },
        removeItem: function(itemId) {
            this._removeItem(itemId);
        },
        select: function(itemId) {
            this._select(itemId);
        },
        getSelectedItem: function() {
            return this._getSelectedItem();
        },
        setInputValue: function(value, options) {
            this._setInputValue(value, options);
        },
        getInputValue: function() {
            return this._getInputValue();
        },
        clearInputValue: function() {
            this._clearInputValue();
        },
        setFocus: function(focus) {
            this._setFocus(focus);
        },
        setBlur: function() {
            this._setBlur();
        },
        setEnabled: function(enabled) {
            this._setEnabled(enabled);
        },
        setError: function(isError, errorMsg) {
            this._setError(isError, errorMsg);
        },
        setItems: function(items) {
            this._setItems(items);
        },
        //</editor-fold>

        //<editor-fold desc="privateFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        _initialize: function (options) {
            this.logger = Logger.getLogger("Singleselect");
            this.logger.info("Initializing Singleselect", "Singleselect:_initialize", {options: options});

            this.model = _initSingleselectModel(options);
            this.listOptions = _initListOptions(options);
            this.inputFieldOptions = _initInputFieldOptions(options);

            this.theme = _.has(options, "theme") ? options.theme : THEME.DEFAULT;
            this.permutation = _.has(options, "permutation") ? options.permutation : PERMUTATION.B;
            this.container = options.container;
        },

        _onRender: function() {
            this.logger.info("Rendering Singleselect", "Singleselect:_onRender");

            this.$el.toggleClass(FLOATING_CLASS_NAME, this.model.isFloating());
            if (this.container) {
                this.container.append(this.$el);
            }

            this._createAndRenderList();
            this._createAndRenderInputField();
        },

        _createAndRenderList: function() {
            this.logger.info("Rendering Singleselect List", "Singleselect:_createAndRenderList");

            var listOptions = this.listOptions;
            listOptions.container = this.ui.list;
            listOptions.selectable = false;
            listOptions.hasCheckbox = false;
            listOptions.theme = this.theme.LIST;

            var listEvents = {};
            listEvents[List.TRIGGERING.CLICK] = "_onListItemClick";
            listEvents[List.TRIGGERING.ACTION_REMOVE] = "_onListItemRemove";

            this.logger.debug("Singleselect List Options", "Singleselect:_createAndRenderList", {options:listOptions, event:listEvents});
            this.uiComponents.host$.createAndRender("list", {
                type: List,
                options: listOptions,
                events: listEvents
            });
        },

        _createAndRenderInputField: function() {
            this.logger.info("Rendering Singleselect TagsContainer", "Singleselect:_createAndRenderInputField");

            var inputFieldOptions = this.inputFieldOptions;
            inputFieldOptions.el = this.ui.inputField;
            inputFieldOptions.permutation = this.permutation;
            inputFieldOptions.theme = this.theme.INPUT_FIELD;
            if (this.model.hasSelectedId()) {
                var listItem = this._getListItemById(this.model.getLastSelectedId());
                inputFieldOptions.value = (!_.isEmpty(listItem)) ? listItem.value : "";
            }

            var inputFieldEvents = {};
            inputFieldEvents[InputField.TRIGGERING.ONFOCUS] = "_onInputFieldFocus";
            inputFieldEvents[InputField.TRIGGERING.ONBLUR] = "_onInputFieldBlur";
            inputFieldEvents[InputField.TRIGGERING.ONCLICKOUTSIDE] = "_onInputFieldClickOutside";
            inputFieldEvents[InputField.TRIGGERING.CHANGE] = "_onInputFieldChange";
            inputFieldEvents[InputField.TRIGGERING.ENTER_PRESSED] = "_onInputFieldEnter";
            inputFieldEvents[InputField.TRIGGERING.ARROW_PRESSED] = "_onInputFieldArrow";

            this.logger.debug("Singleselect InputField Options", "Singleselect:_createAndRenderInputField", {options:inputFieldOptions, event:inputFieldEvents});
            this.uiComponents.host$.createAndRender("inputField", {
                type: InputField,
                options: inputFieldOptions,
                events: inputFieldEvents
            });
        },

        _onListItemClick: function(componentId, eventName, listItem) {
            var listItemId = listItem.id;

            this.logger.info("Singleselect List Item Click", "Singleselect:_onListItemClick", {listItemId:listItemId});

            if (listItem.id === List.NEW_ITEM_ID) {
                this._onListItemNewItemClick();
            }
            else if (listItem.id !== List.NO_ITEMS_ID) {
                this._onListItemSelect(listItem);
            }
        },

        _onListItemRemove: function(componentId, eventName, listItem) {
            var listItemId = listItem.id;
            this.logger.info("Singleselect List Item Remove", "Singleselect:_onListItemRemove", {listItemId:listItemId});
            this.trigger(TRIGGERING.REMOVE, listItem);
        },

        _onListItemSelect: function(listItem) {
            this.logger.debug("Singleselect List Item Select", "Singleselect:_onListItemSelect");

            var value = listItem.value;
            this.uiComponents.inputField.setValue(value);

            this.model.setLastSelectedId(listItem.id);
            this.trigger(TRIGGERING.CHANGE, {value: value, item:listItem});
        },
        _onListItemNewItemClick: function() {
            this.logger.debug("Singleselect List Item New", "Singleselect:_onListItemNewItemClick");

            var inputValue = this.uiComponents.tagsContainer.getInputValue();
            inputValue = (this.model.isTrim()) ? inputValue.trim() : inputValue;

            this.trigger(TRIGGERING.CREATE, {value: inputValue});
        },

        _onInputFieldFocus: function(componentId, eventName, obj) {
            this.logger.info("Singleselect InputField Focus", "Singleselect:_onInputFieldFocus");

            var value = this.uiComponents.inputField.getValue();
            value = (this.model.isTrim()) ? value.trim() : value;

            if (this.model.isAsyncFilter()) {
                this._asyncFilterList(value);
            }
            else {
                this._filterList(value);
                var needToScroll = !this._isListShown();
                this._showList(true);
                this.uiComponents.list.clearActiveItem();
                if (needToScroll) {
                    this.uiComponents.list.scrollTop(0);
                }

                var listItem = this._getListItemByValue(value); // show list only if the current value is not an existing valid value from the list
                if (!_.isEmpty(listItem)) {
                    this._showList(false);
                }
            }
        },

        _onInputFieldBlur: function(componentId, eventName, inputValue, data) {
            this.logger.info("Singleselect InputField Blur", "Singleselect:_onInputFieldBlur");

            if (data.lastKeyDown === $.ui.keyCode.TAB) {
                this._filterList("");
                this._showList(false);
                this.trigger(TRIGGERING.BLUR);
            }
            else if (data.lastKeyDown === $.ui.keyCode.ENTER) {
                var value = this.uiComponents.inputField.getValue();
                value = (this.model.isTrim()) ? value.trim() : value;
                var listItem = this._getListItemByValue(value);
                if (!_.isEmpty(listItem)) {
                    this._filterList("");
                    this._showList(false);
                    this.trigger(TRIGGERING.BLUR);
                }
            }
        },

        _onInputFieldClickOutside: function(componentId, eventName) {
            this._filterList("");
            this._showList(false);
            this.trigger(TRIGGERING.BLUR);
        },

        _onInputFieldChange: function(componentId, eventName, value) {
            value = (this.model.isTrim()) ? value.trim() : value;

            if (this.model.isAsyncFilter()) {
                this._asyncFilterList(value);
            }
            else {
                this._filterList(value);
                this._showList(true);
            }

            this.trigger(TRIGGERING.INPUT_CHANGE, {value: value});
        },

        _onInputFieldEnter: function(componentId, eventName, obj) {
            var value = (this.model.isTrim()) ? obj.value.trim() : obj.value;

            if (this.model.isAsyncFilter() && value.length < this.model.getAsyncFilterMinChars()) { // if we are on async filter and the value is less than minimum - ignore
                return;
            }

            if (this.uiComponents.list.hasActiveItem()) {
                this._onInputFieldEnterListActive(value);
            }
            else {
                this._onInputFieldEnterListNotActive(value);
            }
        },

        _onInputFieldEnterListActive: function(value) {
            this.logger.debug("Singleselect - 'Create' by List", "Singleselect:_onInputFieldEnterListActive");

            var id = this.uiComponents.list.getActiveItem();
            var listItem = this._getListItemById(id);
            if (!_.isEmpty(listItem)) {
                this.logger.debug("Singleselect - valid selected item", "Singleselect:_onInputFieldEnterListActive", {listItem:listItem});
                this.uiComponents.inputField.setValue(listItem.value);
                this.model.setLastSelectedId(id);
                this.trigger(TRIGGERING.CHANGE, {value: listItem.value, item:listItem});

                this._setBlur();
            }
            else if (id === List.NEW_ITEM_ID) {
                this.logger.debug("Singleselect - selected item is 'create new item'", "Singleselect:_onInputFieldEnterListActive");
                this.trigger(TRIGGERING.CREATE, {value: value});
            }
        },
        _onInputFieldEnterListNotActive: function(value) {
            this.logger.debug("Singleselect - 'Create' by InputField", "Singleselect:_onInputFieldEnterListNotActive");

            var listItem = this._getListItemByValue(value);
            if (!_.isEmpty(listItem)) {
                this.logger.debug("Singleselect - valid selected item", "Singleselect:_onInputFieldEnterListNotActive", {listItem:listItem});
                this.uiComponents.inputField.setValue(value);
                this.model.setLastSelectedId(listItem.id);
                this.trigger(TRIGGERING.CHANGE, {value: value, item:listItem});

                this._setBlur();
            }
            else if(!_.isEmpty(value)) {
                this.logger.debug("Singleselect - create new item", "Singleselect:_onInputFieldEnterListNotActive");
                this.trigger(TRIGGERING.CREATE, {value: value});
            }
        },

        _onInputFieldArrow: function(componentId, eventName, obj) {
            this.logger.info("Singleselect InputField Input Arrow", "Singleselect:_onInputFieldArrow");
            this.uiComponents.list.moveSelection(obj);
        },

        _asyncFilterList: function(value) {
            this.logger.debug("Singleselect async filter", "Singleselect:_asyncFilterList", {value:value});

            if (value.length >= this.model.getAsyncFilterMinChars()) {
                if (value !== this.model.getFilterValue()) {
                    this._showLoader(true);
                    this.trigger(TRIGGERING.FILTER, {value:value, success: _.bind(this._onAsyncFilterSuccess,this)});
                }
                else {
                    this._showList(true);
                }
            }
            else {
                this._showList(false);
            }

            this.model.setFilterValue(value);
        },

        _onAsyncFilterSuccess: function(listItems) {
            this.logger.info("Singleselect async filter success callback", "Singleselect:_onAsyncFilterSuccess", {value:listItems});

            this.uiComponents.list.setItems(listItems, {filter:this.model.getFilterValue()});

            this._showList(true);
            this._showLoader(false);
        },

        _showLoader: function(show, isFullLoader) {
            this.logger.info("Singleselect show loader", "Singleselect:_showLoader", {show:show});

            if (this.loader) {
                this.loader.close();
            }

            if (this.ui.loader && _.isFunction(this.ui.loader.toggleClass)) {
                this.ui.loader.toggleClass("hide", !show);
                if (!isFullLoader) {
                    this.ui.loader.toggleClass("list-hidden", !this._isListShown());
                }
            }

            if (show) {
                var loaderPermutation = (isFullLoader) ? Loader.PERMUTATION.D : Loader.PERMUTATION.G;
                var loaderElement = (isFullLoader) ? this.$el : this.ui.loader;
                this.loader = new Loader({
                    permutation: loaderPermutation,
                    el: loaderElement
                });
                this.loader.render();
            }
        },

        _filterList: function(value) {
            this.logger.debug("Singleselect filter list", "Singleselect:_filterList", {value:value});
            var pageNumber = (value !== this.model.getFilterValue()) ? 1 : null;
            this.model.setFilterValue(value);
            this.uiComponents.list.filter(value, pageNumber);
        },

        _showList: function(show) {
            this.ui.list.toggleClass("hide", !show);
        },

        _isListShown: function() {
            return !this.ui.list.hasClass("hide");
        },

        _addItem: function(item) {
            this.uiComponents.list.addItem(item);
            if (item.selected) {
                this.uiComponents.inputField.setValue(item.value);
            }
        },

        _removeItem: function(itemId) {
            this.uiComponents.list.removeItem(itemId);
        },

        _select: function(itemId) {
            this.model.setLastSelectedId(itemId);
            this.uiComponents.list.select(itemId);
            var listItem = this._getListItemById(itemId);
            this.uiComponents.inputField.setValue(listItem.value);
        },

        _getSelectedItem: function() {
            var listItem;
            var selectedItem = SingleselectModel.NO_ITEM_SELECTED;
            var currentInputValue = this.uiComponents.inputField.getValue();
            currentInputValue = (this.model.isTrim()) ? currentInputValue.trim() : currentInputValue;

            if (this.model.hasSelectedId()) {
                var selectedId = this.model.getLastSelectedId();
                listItem = this._getListItemById(selectedId);
                if (!_.isEmpty(listItem) && listItem.value === currentInputValue) {
                    selectedItem = listItem;
                }
                else {
                    selectedItem = this._getSelectedItemByInputValue();
                }
            }
            else {
                selectedItem = this._getSelectedItemByInputValue();
            }

            return selectedItem;
        },

        _getSelectedItemByInputValue: function() {
            var selectedItem = SingleselectModel.NO_ITEM_SELECTED;
            var currentInputValue = this.uiComponents.inputField.getValue();
            currentInputValue = (this.model.isTrim()) ? currentInputValue.trim() : currentInputValue;
            var listItem = this._getListItemByValue(currentInputValue);
            if (!_.isEmpty(listItem)) {
                selectedItem = listItem;
            }

            return selectedItem;
        },

        _setInputValue: function(value, options) {
            this.uiComponents.inputField.setValue(value, options);
        },

        _getInputValue: function() {
            return this.uiComponents.inputField.getValue();
        },

        _clearInputValue: function() {
            this.uiComponents.inputField.setValue("");
        },

        _setFocus: function(focus) {
            return this.uiComponents.inputField.setFocus(focus);
        },

        _setBlur: function() {
            this.uiComponents.inputField.blurInput();
        },

        _setEnabled: function(enabled) {
            this._showList(false);
            this.uiComponents.inputField.setEnabled(enabled);
        },

        _setError: function(isError, errorMsg) {
            _.defer(_.bind(this.uiComponents.inputField.setError, this.uiComponents.inputField, isError, errorMsg));
        },

        _setItems: function(items) {
            this.uiComponents.list.setItems(items);
        },

        _getListItemById: function(itemId) {
            var listItems = this.uiComponents.list.getAllItems();
            var listItem = _.find(listItems, {id:itemId});

            return listItem;
        },

        _getListItemByValue: function(itemValue) {
            var listItems = this.uiComponents.list.getAllItems();
            var listItem = _.find(listItems, function(item) {
                return (item.value.toString().toLowerCase() === itemValue.toString().toLowerCase());
            });

            return listItem;
        },

        _onClose: function() {
            this.logger.info("Closing Singleselect", "Singleselect:_onClose");
            this._showLoader(false);
        }

        //</editor-fold>

    });

    function _mapListObjToTagsContainerObj(listObj) {
        return {
            id: listObj.id,
            value: listObj.value
        };
    }

    function _initSingleselectModel(options) {
        var model = new SingleselectModel();

        if (_.has(options, "asyncFilter")) {
            model.setAsyncFilter(options.asyncFilter);
        }

        if (_.has(options, "asyncFilterMinChars")) {
            model.setAsyncFilterMinChars(options.asyncFilterMinChars);
        }

        if (_.has(options, "floating")) {
            model.setFloating(options.floating);
        }

        if (_.has(options, "trim")) {
            model.setTrim(options.trim);
        }

        if (_.has(options, "selectedItem")) {
            model.setLastSelectedId(options.selectedItem);
        }

        return model;
    }

    function _initListOptions(options) {
        var listOptions = {};

        listOptions.paging = true;

        if (_.has(options, "items")) {
            listOptions.items = options.items;
        }
        if (_.isObject(options.list)) {
            _.extend(listOptions, options.list);
        }

        return listOptions;
    }

    function _initInputFieldOptions(options) {
        var inputFieldOptions = {};

        if (_.has(options, "enabled")) {
            inputFieldOptions.enabled = options.enabled;
        }

        /*if (_.has(options, "selectedItem")) {
         inputFieldOptions.value = options.selectedItem;
         }*/

        if (_.has(options, "errorPosition")) {
            inputFieldOptions.errorPosition = options.errorPosition;
        }

        if (_.has(options, "errorAlign")) {
            inputFieldOptions.errorAlign = options.errorAlign;
        }

        if (_.isObject(options.inputField)) {
            _.extend(inputFieldOptions, options.inputField);
        }

        return inputFieldOptions;
    }

    Singleselect.ERROR_ALIGN = InputField.ERROR_ALIGN;
    Singleselect.ERROR_POSITION = InputField.ERROR_POSITION;
    Singleselect.NO_ITEM_SELECTED = SingleselectModel.NO_ITEM_SELECTED;
    Singleselect.TRIGGERING = TRIGGERING;
    Singleselect.PERMUTATION = PERMUTATION;
    Singleselect.THEME = THEME;

    return Singleselect;
});
